'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Hero = require('components/Hero/Hero');

var _Hero2 = _interopRequireDefault(_Hero);

var _WorkItem = require('components/WorkItem/WorkItem');

var _WorkItem2 = _interopRequireDefault(_WorkItem);

var _work = require('./work.css');

var _work2 = _interopRequireDefault(_work);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Work = function (_Component) {
  _inherits(Work, _Component);

  function Work() {
    _classCallCheck(this, Work);

    var _this = _possibleConstructorReturn(this, (Work.__proto__ || Object.getPrototypeOf(Work)).call(this));

    _this.state = {
      filter: 'all',
      data: {},
      projects: [],
      fields: [],
      technicalFields: [],
      field: null,
      finishLoading: false,
      hideFields: true
    };
    return _this;
  }

  _createClass(Work, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var fetchProjects = this.props.fetchProjects;


      document.title = 'Work | Soundscape Agency';
      fetchProjects();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var _this2 = this;

      if (this.props.loading !== newProps.loading) {
        if (newProps.data !== null) {
          this.setState({
            data: newProps.data,
            projects: newProps.projects,
            finishLoading: true
          }, function () {
            _this2.handleFields();
          });
        }
      }
    }
  }, {
    key: 'handleFields',
    value: function handleFields() {
      var projects = this.state.projects;

      var allFields = [];
      var alltechnicalFields = [];

      projects.map(function (item) {
        var fields = item.fields;
        var technicalFields = item.technicalFields;

        if (fields.length) {
          fields.map(function (field) {
            allFields.push(field);
          });
        }

        if (technicalFields.length) {
          technicalFields.map(function (field) {
            alltechnicalFields.push(field);
          });
        }
      });

      this.setState({
        fields: _lodash2.default.union(allFields),
        technicalFields: _lodash2.default.union(alltechnicalFields)
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'onFilterChange',
    value: function onFilterChange(filter) {
      this.setState({
        filter: filter,
        hideFields: filter === 'all'
      });
    }
  }, {
    key: 'onFieldChange',
    value: function onFieldChange(field) {
      this.setState({
        field: field === null ? null : field.toLowerCase()
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          projects = _state.projects,
          fields = _state.fields,
          filter = _state.filter,
          technicalFields = _state.technicalFields,
          hideFields = _state.hideFields,
          field = _state.field;


      return _react2.default.createElement(
        'div',
        { className: _work2.default.work },
        _react2.default.createElement(_Hero2.default, {
          isWork: true,
          title: 'our work.',
          onFilterChange: this.onFilterChange.bind(this),
          onFieldChange: this.onFieldChange.bind(this),
          fields: _lodash2.default.uniqBy(fields, 'field'),
          technicalFields: _lodash2.default.uniqBy(technicalFields, 'field'),
          hideFields: hideFields
        }),
        _react2.default.createElement(
          'section',
          { className: _work2.default.listing },
          _react2.default.createElement(
            'div',
            { className: _work2.default.innerList, hidden: filter !== 'creative' },
            projects.map(function (item, index) {
              var isInFilter = true;
              var fields = item.fields;
              var technicalFields = item.technicalFields;

              if (item.fields.length && field !== null) {
                var result = _lodash2.default.find(item.fields, { 'field': field });

                if (result === undefined) {
                  isInFilter = false;
                } else {
                  isInFilter = true;
                }
              } else {
                isInFilter = true;
              }

              if (item.type === 'creative') {
                return _react2.default.createElement(_WorkItem2.default, {
                  key: 'workItem_' + index,
                  url: item.slug,
                  title: item.title,
                  subtitle: item.subtitle,
                  bg: item.mainImage,
                  isInFilter: isInFilter
                });
              }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: _work2.default.innerList, hidden: filter !== 'technical' },
            projects.map(function (item, index) {
              var isInFilter = true;
              var fields = item.fields;
              var technicalFields = item.technicalFields;

              if (item.fields.length && field !== null) {
                var result = _lodash2.default.find(item.fields, { 'field': field });

                if (result === undefined) {
                  isInFilter = false;
                } else {
                  isInFilter = true;
                }
              } else {
                isInFilter = true;
              }

              if (item.type === 'technical') {
                return _react2.default.createElement(_WorkItem2.default, {
                  key: 'workItem_' + index,
                  url: item.slug,
                  title: item.title,
                  subtitle: item.subtitle,
                  bg: item.mainImage,
                  isInFilter: isInFilter
                });
              }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: _work2.default.innerList, hidden: filter !== 'all' },
            projects.map(function (item, index) {
              var isInFilter = true;
              var fields = item.fields;
              var technicalFields = item.technicalFields;

              return _react2.default.createElement(_WorkItem2.default, {
                key: 'workItem_' + index,
                url: item.slug,
                title: item.title,
                subtitle: item.subtitle,
                bg: item.mainImage,
                isInFilter: isInFilter
              });
            })
          )
        )
      );
    }
  }]);

  return Work;
}(_react.Component);

exports.default = Work;


Work.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Work/Work.js
// module id = 341
// module chunks = 1